define(['app', '../templates/msg.html'], function (app, msgTmpl) {
  return app.Marionette.ItemView.extend({
    template: msgTmpl,
    tagName: 'li',

    ui: {
      counter: '.countdown'
    },

    scaleCounter: function () {
      var self = this
      var seconds = parseInt(this.ui.counter.html())
      var interval = setInterval(function () {
        if (seconds === 0) {
          clearInterval(interval)
          return self.model.destroy()
        }
        seconds = seconds - 1
        self.ui.counter.html(seconds)
      }, 1000)
    },

    onRender: function () {
      if (this.ui.counter.length > 0) {
        this.scaleCounter()
      }
    }
  })
})
